import { Localized } from "@fluent/react";
import { DocumentTeamMemberRole } from "../teamMemberApi";

export const TeamMemberRoleLabel = ({ role }: { role: DocumentTeamMemberRole }) => {
    switch (role) {
        case "C_CLOSED":
            return <Localized id="urs-role-creator-closed">
                <span>_Poprzedni autor</span>
            </Localized>
        case "C":
            return <Localized id="urs-role-creator">
                <span>_Author</span>
            </Localized>
        case "E":
            return <Localized id="urs-role-editor">
                <span>_Edytor</span>
            </Localized>
        case "R":
            return <Localized id="urs-role-reviever">
                <span>_Opiniujący</span>
            </Localized>
        case "A":
            return <Localized id="urs-role-approver">

                <span>_Zatwierdzający</span>
            </Localized>
        case "AR":
            return <Localized id="urs-role-reviever-and-approver">
                <span>_Opiniujący + Zatwierdzający</span>
            </Localized>
        case "V":
            return <Localized id="urs-role-viewer">
                <span>_Obserwator</span>
            </Localized>
        case "EXT_R":
            return <Localized id="urs-role-external-reviever">
                <span>_Zewnętrzny opiniujący</span>
            </Localized>
        case "P":
            return <Localized id="urs-role-publisher">
                <span>_publisher</span>
            </Localized>
        default:
            return <span></span>
    }
}